module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_5010.9c06458c.png";